import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarDaysIcon, ExternalLinkIcon, PartyPopperIcon } from 'lucide-react';
import { BadgeDivider } from './Badge';
export function Shows() {
  return <section id="shows" className="relative w-full bg-[var(--vu-black)] py-20 px-5 overflow-hidden grain" data-id="element-80" data-mp="2ylr5yprlmw3x">
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-81" data-mp="2ulysbynclzrp">
        <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-82" data-mp="26wnzr4g5jbon">
          On The Marquee
        </p>
        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-83" data-mp="21ycocpa7kt4b">
          Catch Us Live
        </h2>
        <BadgeDivider label="♬" data-id="element-84" data-mp="2axg8lwl43eke" />

        {/* Marquee flyer for the recurring residency */}
        <motion.a href="https://www.twistedtikistpetebeach.com" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative mt-4 block border-4 border-[var(--vu-gold)] bg-[var(--vu-red)] px-6 py-10 text-[var(--vu-cream)] shadow-[8px_8px_0_0_var(--vu-navy)] transition-transform hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" aria-label="Visit the Twisted Tiki website" data-id="element-85" data-mp="1n7dktso8curl">
          <div className="absolute inset-2 border border-[var(--vu-cream)]/30 pointer-events-none" data-id="element-86" data-mp="2j31em5tnr22t" />
          <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs" data-id="element-87" data-mp="2o2nruf9hkibm">
            Residency
          </p>
          <h3 className="mt-2 flex items-center justify-center gap-3 font-display text-5xl uppercase leading-none sm:text-7xl" data-id="element-88" data-mp="2t2ih6edm4zuk">
            Twisted Tiki
            <ExternalLinkIcon className="h-5 w-5 text-[var(--vu-gold)] sm:h-6 sm:w-6" aria-hidden="true" data-id="element-89" data-mp="3ehxy65dvvr1" />
          </h3>
          <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 font-cond uppercase tracking-wider text-sm" data-id="element-90" data-mp="24dv796y2sjbx">
            <span className="flex items-center gap-2" data-id="element-91" data-mp="1zes3rqxqul62">
              <MapPinIcon className="w-4 h-4 text-[var(--vu-gold)]" data-id="element-92" data-mp="2dfkvy50kp460" />
              Corey Ave, St. Pete Beach
            </span>
            <span className="flex items-center gap-2" data-id="element-93" data-mp="29esmbansgx97">
              <CalendarDaysIcon className="w-4 h-4 text-[var(--vu-gold)]" data-id="element-94" data-mp="1lnn97398gj2l" />
              Recurring Live Sets
            </span>
          </div>
        </motion.a>

        {/* Private events + booking */}
        <div className="mt-10 bg-[var(--vu-navy)] border-2 border-[var(--vu-gold)]/40 p-8" data-id="element-95" data-mp="1ufynjqr2og27">
          <PartyPopperIcon className="w-8 h-8 text-[var(--vu-gold)] mx-auto" data-id="element-96" data-mp="1ppi5tug7y8a1" />
          <p className="mt-3 font-body text-[var(--vu-cream)]/85 text-base leading-relaxed" data-id="element-97" data-mp="1pndy11f78p4h">
            We also play <strong className="text-[var(--vu-cream)]" data-id="element-98" data-mp="11xjk0gj58uin">private events, weddings,
            and corporate parties.</strong> Reach out and we'll put together a quote for your date.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4" data-id="element-99" data-mp="nsj7ekp06bt8">
            <a href="https://www.thebash.com/acoustic-guitar/nick-sette" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-gold)] text-[var(--vu-black)] font-display uppercase tracking-wider px-7 py-3 border-2 border-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-100" data-mp="smngpalqqvxh">
              Book Us on The Bash
              <ExternalLinkIcon className="w-4 h-4" data-id="element-101" data-mp="wp1x7o1xtjll" />
            </a>
            <a href="https://gotonight.com/profile/?artistId=244686" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-gold)] text-[var(--vu-black)] font-display uppercase tracking-wider px-7 py-3 border-2 border-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-102" data-mp="11k7kaq72t4b9">
              Find Us on GoTonight
              <ExternalLinkIcon className="w-4 h-4" data-id="element-103" data-mp="3sr01u3wdhubz" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}